<div class="smart-template-part-container">
  <!-- Header Section -->
  <div class="part-header">
    <div class="header-content">
      <h2 class="part-title">
        <mat-icon>extension</mat-icon>
        {{ editMode ? 'Editare Parte Template' : 'Creare Parte Template' }}
      </h2>
      <p class="part-subtitle">
        Creează și gestionează părți reutilizabile pentru template-uri inteligente
      </p>
    </div>
    <div class="header-actions">
      <button mat-stroked-button (click)="previewPart()" [disabled]="!isFormValid()">
        <mat-icon>visibility</mat-icon>
        Preview
      </button>
      <button mat-raised-button color="primary" (click)="savePart()" [disabled]="!isFormValid() || isSaving">
        <mat-icon>save</mat-icon>
        {{ isSaving ? 'Se salvează...' : 'Salvează' }}
      </button>
    </div>
  </div>

  <div class="part-content">
    <!-- Left Panel - Part Configuration -->
    <div class="left-panel">
      <mat-card class="config-card">
        <mat-card-header>
          <mat-card-title>Configurare Parte</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <!-- Basic Information -->
          <div class="form-section">
            <h3>Informații de bază</h3>
            
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Nume parte</mat-label>
              <input matInput [(ngModel)]="templatePart.name" placeholder="Introduceti numele părții">
              <mat-error *ngIf="!templatePart.name">Numele este obligatoriu</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Descriere</mat-label>
              <textarea matInput [(ngModel)]="templatePart.description" rows="3" 
                placeholder="Descrierea părții (opțional)"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Tip parte</mat-label>
              <mat-select [(ngModel)]="templatePart.type">
                <mat-option value="header">Header</mat-option>
                <mat-option value="content">Conținut</mat-option>
                <mat-option value="footer">Footer</mat-option>
                <mat-option value="signature">Semnătură</mat-option>
                <mat-option value="custom">Personalizat</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Categorie</mat-label>
              <mat-select [(ngModel)]="templatePart.category_id">
                <mat-option value="">Selectează categoria</mat-option>
                <mat-option *ngFor="let category of categories" [value]="category.id">
                  {{ category.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Part Settings -->
          <div class="form-section">
            <h3>Setări parte</h3>
            
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Poziție în document</mat-label>
              <mat-select [(ngModel)]="templatePart.position">
                <mat-option value="top">Sus (Header)</mat-option>
                <mat-option value="middle">Mijloc (Conținut)</mat-option>
                <mat-option value="bottom">Jos (Footer)</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Prioritate</mat-label>
              <mat-select [(ngModel)]="templatePart.priority">
                <mat-option [value]="1">Scăzută</mat-option>
                <mat-option [value]="2">Normală</mat-option>
                <mat-option [value]="3">Ridicată</mat-option>
                <mat-option [value]="4">Critică</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="half-width">
              <mat-label>Ordine afișare</mat-label>
              <input matInput type="number" [(ngModel)]="templatePart.order_index" min="0">
            </mat-form-field>

            <div class="checkbox-group">
              <mat-checkbox [(ngModel)]="templatePart.is_active">Parte activă</mat-checkbox>
              <mat-checkbox [(ngModel)]="templatePart.is_public">Parte publică</mat-checkbox>
              <mat-checkbox [(ngModel)]="templatePart.is_required">Parte obligatorie</mat-checkbox>
              <mat-checkbox [(ngModel)]="templatePart.is_repeatable">Parte repetabilă</mat-checkbox>
            </div>
          </div>

          <!-- Tags and Metadata -->
          <div class="form-section">
            <h3>Metadata</h3>
            
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Tags (separate prin virgulă)</mat-label>
              <input matInput [(ngModel)]="templatePart.tags" 
                placeholder="ex: header, antet, oficial">
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Versiune</mat-label>
              <input matInput [(ngModel)]="templatePart.version" placeholder="1.0.0">
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- Variables and Parameters -->
      <mat-card class="variables-card">
        <mat-card-header>
          <mat-card-title>Variabile disponibile</mat-card-title>
          <button mat-icon-button (click)="addVariable()">
            <mat-icon>add</mat-icon>
          </button>
        </mat-card-header>
        <mat-card-content>
          <div class="variables-list" *ngIf="templateVariables.length > 0">
            <div class="variable-item" *ngFor="let variable of templateVariables; let i = index">
              <mat-form-field appearance="outline" class="variable-name">
                <mat-label>Nume variabilă</mat-label>
                <input matInput [(ngModel)]="variable.name" placeholder="Introduceți numele variabilei">
              </mat-form-field>
              <mat-form-field appearance="outline" class="variable-description">
                <mat-label>Descriere</mat-label>
                <input matInput [(ngModel)]="variable.description" placeholder="Descrierea variabilei">
              </mat-form-field>
              <button mat-icon-button color="warn" (click)="removeVariable(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
          <div class="empty-state" *ngIf="templateVariables.length === 0">
            <mat-icon>code</mat-icon>
            <p>Nu există variabile definite</p>
            <button mat-stroked-button (click)="addVariable()">
              <mat-icon>add</mat-icon>
              Adaugă prima variabilă
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Right Panel - Content Editor -->
    <div class="right-panel">
      <mat-card class="editor-card">
        <mat-card-header>
          <mat-card-title>Editor conținut</mat-card-title>
          <div class="editor-actions">
            <button mat-icon-button [matMenuTriggerFor]="insertMenu" matTooltip="Inserează variabile">
              <mat-icon>add_circle</mat-icon>
            </button>
            <mat-menu #insertMenu="matMenu">
              <button mat-menu-item *ngFor="let variable of templateVariables" 
                (click)="insertVariable(variable.name)">
                <mat-icon>code</mat-icon>
                <span>{{ variable.name }}</span>
              </button>
              <mat-divider *ngIf="templateVariables.length > 0"></mat-divider>
              <button mat-menu-item (click)="insertCommonVariable('data_curenta')">
                <mat-icon>today</mat-icon>
                <span>Data curentă</span>
              </button>
              <button mat-menu-item (click)="insertCommonVariable('nume_utilizator')">
                <mat-icon>person</mat-icon>
                <span>Numele utilizatorului</span>
              </button>
              <button mat-menu-item (click)="insertCommonVariable('organizatie')">
                <mat-icon>business</mat-icon>
                <span>Organizația</span>
              </button>
            </mat-menu>
            
            <button mat-icon-button (click)="toggleEditorMode()" matTooltip="Comută modul editor">
              <mat-icon>{{ editorMode === 'visual' ? 'code' : 'edit' }}</mat-icon>
            </button>
          </div>
        </mat-card-header>
        <mat-card-content>
          <!-- Visual Editor -->
          <div class="editor-container" *ngIf="editorMode === 'visual'">
            <div class="editor-toolbar">
              <button mat-icon-button (click)="formatText('bold')" matTooltip="Bold">
                <mat-icon>format_bold</mat-icon>
              </button>
              <button mat-icon-button (click)="formatText('italic')" matTooltip="Italic">
                <mat-icon>format_italic</mat-icon>
              </button>
              <button mat-icon-button (click)="formatText('underline')" matTooltip="Underline">
                <mat-icon>format_underlined</mat-icon>
              </button>
              <mat-divider vertical></mat-divider>
              <button mat-icon-button (click)="formatText('justifyLeft')" matTooltip="Align Left">
                <mat-icon>format_align_left</mat-icon>
              </button>
              <button mat-icon-button (click)="formatText('justifyCenter')" matTooltip="Align Center">
                <mat-icon>format_align_center</mat-icon>
              </button>
              <button mat-icon-button (click)="formatText('justifyRight')" matTooltip="Align Right">
                <mat-icon>format_align_right</mat-icon>
              </button>
            </div>
            
            <div class="visual-editor" 
                 contenteditable="true" 
                 (input)="onContentChange($event)"
                 [innerHTML]="templatePart.content">
            </div>
          </div>

          <!-- Code Editor -->
          <div class="editor-container" *ngIf="editorMode === 'code'">
            <mat-form-field appearance="outline" class="full-width code-editor">
              <mat-label>Conținut HTML</mat-label>
              <textarea matInput 
                        [(ngModel)]="templatePart.content" 
                        rows="20"
                        placeholder="Introduceti conținutul HTML al părții..."
                        class="code-textarea">
              </textarea>
            </mat-form-field>
          </div>

          <!-- Content Statistics -->
          <div class="content-stats">
            <span class="stat-item">
              <mat-icon>text_fields</mat-icon>
              {{ getWordCount() }} cuvinte
            </span>
            <span class="stat-item">
              <mat-icon>code</mat-icon>
              {{ getVariableCount() }} variabile
            </span>
            <span class="stat-item">
              <mat-icon>straighten</mat-icon>
              {{ getCharacterCount() }} caractere
            </span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Preview Dialog -->
  <div class="preview-overlay" *ngIf="showPreview" (click)="closePreview()">
    <div class="preview-dialog" (click)="$event.stopPropagation()">
      <div class="preview-header">
        <h3>Preview Parte Template</h3>
        <button mat-icon-button (click)="closePreview()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="preview-content">
        <div class="preview-part" [innerHTML]="previewHtml"></div>
      </div>
      <div class="preview-actions">
        <button mat-stroked-button (click)="closePreview()">Închide</button>
        <button mat-raised-button color="primary" (click)="exportPreview()">
          <mat-icon>download</mat-icon>
          Export HTML
        </button>
      </div>
    </div>
  </div>
</div>